import { render, staticRenderFns } from "./SendMessagesTab.vue?vue&type=template&id=c4c8ae0e&scoped=true&lang=pug"
import script from "./SendMessagesTab.vue?vue&type=script&lang=ts"
export * from "./SendMessagesTab.vue?vue&type=script&lang=ts"
import style0 from "./SendMessagesTab.vue?vue&type=style&index=0&id=c4c8ae0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c8ae0e",
  null
  
)

export default component.exports